import { isTrackingEnabled } from '@/utils/statistics/is-tracking-enabled';

export type GaParams = Record<string, unknown>;

const getPageLocation = (): string | undefined => {
  if (typeof window === 'undefined') return undefined;
  return window.location?.href;
};

const allowGtag = (): boolean => {
  return isTrackingEnabled();
};

const shouldDebug = (): boolean => {
  if (typeof window === 'undefined') return false;
  // Opt-in debug: set `window.__ANALYTICS_DEBUG__ = true` in devtools.
  return Boolean(import.meta.env.DEV && window.__ANALYTICS_DEBUG__);
};

export function trackEvent(event: string, params: GaParams = {}): void {
  if (typeof window === 'undefined' || !isTrackingEnabled()) return;

  if (shouldDebug()) {
    console.debug('[analytics]', event, params);
  }

  if (Array.isArray(window.dataLayer)) {
    window.dataLayer.push({ event, ...params });
    return;
  }

  if (allowGtag() && typeof window.gtag === 'function') {
    window.gtag('event', event, params);
  }
}

export function trackPageView(pagePath: string): void {
  const pageLocation = getPageLocation();
  trackEvent('page_view', {
    page_path: pagePath,
    ...(pageLocation ? { page_location: pageLocation } : {}),
  });
}
